import type {FontSizeOption} from '@FormMakerReact/layout/form-maker-right-panel/controls/font-size-control/font-size-control.types';
import {FormMakerFontSize} from '@FormMakerReact/lib/form-maker-typography';

export const DEFAULT_TEXT_COLOR = '#FFFFFF';
export const DEFAULT_BG_COLOR = '#3FBCE8';
export const DEFAULT_BORDER_COLOR = '#FFFFFF';

export const BUTTON_SIZES: readonly FontSizeOption[] = [
  {label: 'Aa', value: FormMakerFontSize.PX_14},
  {label: 'Aa', value: FormMakerFontSize.PX_16},
  {label: 'Aa', value: FormMakerFontSize.PX_18},
  {label: 'Aa', value: FormMakerFontSize.PX_20},
];
